import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, Tooltip, IconButton } from '@material-ui/core';
import { BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import MaterialTable from 'material-table';
import * as actions from './store/integrityCheckActions';
import * as action from '../../np-core/Auth/store/authActions';
import { Refresh } from '@material-ui/icons';
import Solve from './Solve';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const IntegrityCheckList = props => {
    const { classes, translations, onFetchIntegrityCheck, onFetchIntegrityCheckCount, fetching, saveColumnsFilter, activeCustomer, tableColumns, onSolveIntegrityCheck, solveModalState, handleSolve, tableRef } = props;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []);

    const [tableOptions, setTableOptions] = useState({
        filtering: false,
        sorting: false,
        selection: false,
        search: false,
        minBodyHeight: window.innerHeight - 198 < 300 ? 300 : window.innerHeight - 198,
        maxBodyHeight: window.innerHeight - 198,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    });


    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await onFetchIntegrityCheckCount(query);
        if (!query['page'] && !rowsPageSizeInit.includes(query['pageSize'])) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onFetchIntegrityCheck(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography className={classes.typography}>{translations['integrity_checks'] || 'Integrity checks'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`IntegrityCheck`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const handleSolveAction = () => {
        handleSolve()
        tableRef.current && tableRef.current.onQueryChange()

    }

    return (
        <Paper>
            <MaterialTable
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                isLoading={fetching}
                localization={localization(translations)}
                onChangeRowsPerPage={(size) => {
                    setTableOptions({ ...tableOptions, pageSize: size })
                    pageSize = size
                }}
                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
            <Solve translations={translations} handleSolve={handleSolveAction} onSolveIntegrityCheck={onSolveIntegrityCheck} activeCustomer={activeCustomer} solveModalState={solveModalState}></Solve>
        </Paper>
    );
};


const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        fetching: state.admin.integrityCheck.fetching
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchIntegrityCheckCount: filter => dispatch(actions.fetchIntegrityCheckCount(filter)),
        onFetchIntegrityCheck: filter => dispatch(actions.fetchIntegrityCheck(filter)),
        onSolveIntegrityCheck: data => dispatch(actions.solveIntegrityCheck(data)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(IntegrityCheckList));


